import BusEvent from "common/services/BusEvent"
import { deleteTask } from "tasks/api"

const deleteTaskUseCase = task => {
    return deleteTask(task.id).then(() => BusEvent.publish(BusEvent.DELETE_TASK, task))
}

export default deleteTaskUseCase